const CONTROL_CHARS_REGEX = /[\u0000-\u0008\u000B\u000C\u000E-\u001F\u007F]/g;
const NON_BMP_REGEX = /[\u{10000}-\u{10FFFF}]/gu;
const HTML_BREAK_REGEX = /<\s*br\s*\/?>/gi;
const HTML_BLOCK_CLOSE_REGEX = /<\s*\/\s*(p|div|li|ul|ol|h[1-6])\s*>/gi;
const HTML_TAG_REGEX = /<[^>]+>/g;
const LONG_TOKEN_REGEX = /(\S{80})(?=\S)/g;

export function sanitizePdfText(value) {
  if (value === null || value === undefined) {
    return "";
  }

  if (typeof value === "string") {
    return value
      .replace(HTML_BREAK_REGEX, "\n")
      .replace(HTML_BLOCK_CLOSE_REGEX, "\n")
      .replace(HTML_TAG_REGEX, "")
      .replace(CONTROL_CHARS_REGEX, "")
      .replace(NON_BMP_REGEX, "")
      .replace(/\r\n/g, "\n")
      .replace(/\t/g, " ")
      .replace(LONG_TOKEN_REGEX, "$1 ");
  }

  if (typeof value === "number" || typeof value === "boolean") {
    return String(value);
  }

  if (value instanceof Date) {
    return value.toISOString();
  }

  return "";
}

export function sanitizePdfData(value) {
  if (Array.isArray(value)) {
    return value.map(sanitizePdfData);
  }

  if (value && typeof value === "object" && !(value instanceof Date)) {
    return Object.fromEntries(
      Object.entries(value).map(([key, nestedValue]) => [
        key,
        sanitizePdfData(nestedValue),
      ])
    );
  }

  return sanitizePdfText(value);
}
